export default {
  namespaced: true,
  state: {
    name: 'common'
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common/modules/commontest.js